import { RootState } from '../store';

export const brandsSelector = (state: RootState): RootState['brands'] =>
  state.brands;
